"use client";
import React, { useEffect, useState } from "react";
import HomePage from "./home/page";
import { getCookie } from "../../helper/helper";
import { useRouter } from "next/navigation";
import api from "../../api";
import NewMainLayout from "@/components/layout/newMainLayout";
import { useLocalsListStore } from "@/zustand/localesList";
import Loader from "@/components/loader/loader";
import BuyNowCart from "@/components/common/BuyNowCart";
import { getCheckoutLineItems } from "@/util/utils";
import { useAppCommonStore } from "@/zustand/appCommon";
export default function Home() {
  const router = useRouter();
  const localesList = useLocalsListStore(
    (state: any) => state.localesList
  );

  const locale = localesList.locale || getCookie("locale") || "en-US";
  const {
    checkout,
    setCheckout,
    selectedCountry,
    updateQuantityInCart,
    removeLineItemInCart,
    openModal,
    toggleCartSidebar,
  } = useAppCommonStore((state: any) => ({
    checkout: state.checkout,
    setCheckout: state.setCheckout,
    selectedCountry: state.selectedCountry,
    updateQuantityInCart: state.updateQuantityInCart,
    removeLineItemInCart: state.removeLineItemInCart,
    openModal: state.openModal,
    toggleCartSidebar: state.toggleCartSidebar,
  }));

  // useEffect(() => {
  //   const ageVerified = getCookie("ageVerified");
  //   if (ageVerified != "true") {
  //     router.push("/age-verification");
  //   }
  // }, []);

  const [homePageData, setTemplateData]: any = useState(null);
  const [meta, setMeta]: any = useState({});

  const getHomePageData = (props: any) => {
    api
      .getHomePage(props)
      .then((res: any) => {
        if (res?.data) {
          setMeta(res?.data?.attributes?.seo);
          setTemplateData(res?.data?.attributes?.blocks);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getHomePageData(locale);
    setTemplateData(null);
  }, [locale]);

  useEffect(() => {
    getCheckoutLineItems(selectedCountry.value).then((res) => {
      setCheckout({
        ...res,
      });
    });
  }, []);

  return (
    <main>
      <BuyNowCart
        countryCode={selectedCountry.value}
        openModal={openModal}
        toggleCartSidebar={toggleCartSidebar}
        checkout={checkout}
        updateQuantityInCart={updateQuantityInCart}
        removeLineItemInCart={removeLineItemInCart}
      />
      {homePageData ? (
        <NewMainLayout
          checkout={checkout}
          toggleCartSidebar={toggleCartSidebar}
        >
          <HomePage
            homePageData={homePageData}
            meta={meta ? meta : {}}
          />
        </NewMainLayout>
      ) : (
        <Loader />
      )}
    </main>
  );
}
